import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['input', 'hidden', 'dropdown', 'chevron', 'clear']
  static values = { options: Array }

  connect() {
    this.boundClose = this.closeOnClickOutside.bind(this)
    document.addEventListener('click', this.boundClose)
    this.updateIcons()
  }

  disconnect() {
    document.removeEventListener('click', this.boundClose)
  }

  open() {
    this.renderOptions(this.optionsValue)
    this.dropdownTarget.hidden = false
  }

  filter() {
    const query = this.inputTarget.value.toLowerCase().trim()
    const filtered = query
      ? this.optionsValue.filter((o) => o.text.toLowerCase().includes(query))
      : this.optionsValue
    this.renderOptions(filtered)
    this.dropdownTarget.hidden = false
  }

  select(event) {
    const { value, text } = event.currentTarget.dataset
    this.hiddenTarget.value = value
    this.inputTarget.value = text
    this.dropdownTarget.hidden = true
    this.updateIcons()
  }

  clear() {
    this.hiddenTarget.value = ''
    this.inputTarget.value = ''
    this.updateIcons()
    this.inputTarget.focus()
    this.open()
  }

  keydown(event) {
    if (event.key === 'Escape') {
      this.dropdownTarget.hidden = true
      this.restoreLabel()
    }
  }

  closeOnClickOutside(event) {
    if (!this.element.contains(event.target)) {
      this.dropdownTarget.hidden = true
      this.restoreLabel()
    }
  }

  // private

  restoreLabel() {
    const value = this.hiddenTarget.value
    const option = this.optionsValue.find((o) => String(o.value) === String(value))
    this.inputTarget.value = option ? option.text : ''
  }

  updateIcons() {
    const hasValue = !!this.hiddenTarget.value
    this.clearTarget.hidden = !hasValue
    this.chevronTarget.hidden = hasValue
  }

  renderOptions(options) {
    if (options.length === 0) {
      this.dropdownTarget.innerHTML = `<li class="searchable-select__empty">Aucun résultat</li>`
      return
    }
    const currentValue = this.hiddenTarget.value
    this.dropdownTarget.innerHTML = options
      .map((o) => {
        const isSelected = String(o.value) === String(currentValue)
        const cls = isSelected ? 'searchable-select__option searchable-select__option--selected' : 'searchable-select__option'
        return `<li class="${cls}" data-value="${o.value}" data-text="${o.text}" data-action="click->searchable-select#select">${o.text}</li>`
      })
      .join('')
  }
}
